import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store"

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: "/",
    name: "index",
    redirect: "/order",
    component: () => import("../views/index"),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/views/dashboard/index"),
        meta: { title: "数据看板", keepAlive: true },
      },
      {
        path: "/risk",
        name: "risk",
        component: () => import("@/views/risk/index"),
        meta: { title: "风控配置", keepAlive: true },
      },
      {
        path: "/goods",
        name: "goods",
        component: () => import("@/views/goods/index"),
        meta: { title: "产品管理", keepAlive: true },
      },
      {
        path: "/storehouse",
        name: "storehouse",
        redirect: "/storehouse/index",
        component: () => import("@/views/storehouse/box"),
        children: [
          {
            path: "/storehouse/index",
            name: "storehouseindex",
            component: () => import("@/views/storehouse/index"),
            meta: { title: "仓库管理", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/stock",
            name: "storehousestock",
            component: () => import("@/views/storehouse/stock"),
            meta: { title: "库存列表", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/stockChart",
            name: "storehousestockChart",
            component: () => import("@/views/storehouse/stockChart"),
            meta: { title: "库存甘特图", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/supplier",
            name: "storehousesupplier",
            component: () => import("@/views/storehouse/supplier"),
            meta: { title: "货品方列表", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/accessories",
            name: "storehouseaccessories",
            component: () => import("@/views/storehouse/accessories/index"),
            meta: { title: "配件管理", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/accessoriesMode",
            name: "storehouseaccessoriesMode",
            component: () => import("@/views/storehouse/accessoriesMode"),
            meta: { title: "配件模板", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/combo",
            name: "storehousecombo",
            component: () => import("@/views/storehouse/combo"),
            meta: { title: "套餐管理", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/inventory",
            name: "storehouseinventory",
            component: () => import("@/views/storehouse/inventory/index"),
            meta: { title: "库存盘点", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/replacement",
            name: "storehousereplacement",
            component: () => import("@/views/storehouse/replacement/index"),
            meta: { title: "调货管理", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/markup",
            name: "storehouseMarkup",
            component: () => import("@/views/storehouse/markup/index"),
            meta: { title: "加价管理", activeMenu: "/storehouse", keepAlive: true },
          },
          {
            path: "/storehouse/operation",
            name: "storehouseOperation",
            component: () => import("@/views/storehouse/operation/index"),
            meta: { title: "经营分类", activeMenu: "/storehouse", keepAlive: true },
          }
        ],
      },
      {
        path: "/order",
        redirect: "/order/index",
        component: () => import("@/views/order/box"),
        children: [
          {
            path: "/order/index",
            name: "orderindex",
            component: () => import("@/views/order/index"),
            meta: { title: "订单列表", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/risk",
            name: "orderRisk",
            component: () => import("@/views/order/risk"),
            meta: { title: "风控审核", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/platform",
            name: "orderplatform",
            component: () => import("@/views/order/platform"),
            meta: { title: "渠道管理", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/statistics",
            name: "orderstatistics",
            component: () => import("@/views/order/statistics"),
            meta: { title: "库存统计", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/statisticsList",
            name: "orderstatisticsList",
            component: () => import("@/views/order/statisticsList"),
            meta: { title: "多仓库查询", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/urban_occupancyRate",
            name: "urban_occupancyRate",
            component: () => import("@/views/order/urban_occupancyRate"),
            meta: { title: "城市出租率", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/packageStatistics",
            name: "orderpackageStatistics",
            component: () => import("@/views/order/packageStatistics"),
            meta: { title: "仓库套餐查询", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/serviceStatistics",
            name: "orderserviceStatistics",
            component: () => import("@/views/order/serviceStatistics"),
            meta: { title: "业绩统计", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/salesservice",
            name: "ordersalesservice",
            component: () => import("@/views/order/salesservice"),
            meta: { title: "售后管理", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/salesrefund",
            name: "ordersalesrefund",
            component: () => import("@/views/order/salesrefund"),
            meta: { title: "售后打款", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/external",
            name: "orderexternal",
            component: () => import("@/views/order/external"),
            meta: { title: "外部订单", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/channel",
            name: "orderchannel",
            component: () => import("../views/order/channel"),
            meta: { title: "渠道订单", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/userLog",
            name: "orderuserLog",
            component: () => import("@/views/order/userLog"),
            meta: { title: "日志列表", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/freightRecord",
            name: "orderfreightRecord",
            component: () => import("@/views/order/freightRecord"),
            meta: { title: "顺丰运费记录", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/long",
            name: "orderlong",
            component: () => import("@/views/order/long"),
            meta: { title: "长租订单", activeMenu: "/order", keepAlive: true },
          },
          {
            path: "/order/refund",
            name: "orderrefund",
            component: () => import("@/views/order/refund"),
            meta: { title: "退租列表", activeMenu: "/order", keepAlive: true },
          },
        ],
      },
      {
        path: "/express",
        name: "express",
        component: () => import("@/views/express/index"),
        meta: { title: "快递管理", keepAlive: true },
      },
      {
        path: "/deposit",
        name: "deposit",
        component: () => import("@/views/deposit/index"),
        meta: { title: "押金方式", keepAlive: true },
      },
      {
        path: "/province",
        name: "province",
        component: () => import("@/views/province/index"),
        meta: { title: "发货配置", keepAlive: true },
      },
      {
        path: "/permission",
        name: "permission",
        component: () => import("@/views/permission/index"),
        meta: { title: "权限管理", keepAlive: true },
      },
      {
        path: "/user",
        name: "user",
        component: () => import("@/views/user/index"),
        meta: { title: "员工管理", keepAlive: true },
      },
      {
        path: "/setting",
        name: "setting",
        component: () => import("@/views/setting/index"),
        meta: { title: "商家配置", keepAlive: true },
      },
      {
        path: "/paymodule",
        name: "paymodule",
        component: () => import("@/views/paymodule/index"),
        meta: { title: "付款方式", keepAlive: true },
      },
      {
        path: "/userMoneyLog",
        name: "userMoneyLog",
        component: () => import("@/views/userMoneyLog/index"),
        meta: { title: "分润管理", keepAlive: true },
      },
      {
        path: "/plugin",
        name: "plugin",
        component: () => import("@/views/plugin/index"),
        meta: { title: "插件列表", keepAlive: true },
      },
      {
        path: "/plugin/box",
        name: "pluginbox",
        component: () => import("@/views/plugin/box"),
        meta: { title: "应用列表", keepAlive: false },
      },
      {
        path: "/member",
        name: "member",
        component: () => import("@/views/member/index"),
        meta: { title: "客户异常记录", keepAlive: true },
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login"),
  },
  {
    path: "/warehouse",
    name: "warehouse",
    component: () => import("../views/warehouse/index"),
    meta: { title: "仓库待发货订单", keepAlive: false },
  },
  {
    path: "/store",
    name: "store",
    component: () => import("../views/store/index"),
    meta: { title: "实时库存", keepAlive: false },
  },
  {
    path: "*",
    component: () => import("../views/error/404"),
  },
]

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  let token = store.state.token
  let userInfo = store.state.userInfo
  if (token && userInfo) {
    if (to.path === "/warehouse") {
      if (userInfo.group_id == 1 || userInfo.group_id == 6 || userInfo.group_id == 10 || userInfo.group_id == 14) {
        next()
      } else {
        next("/404")
      }
    } else if (to.path === "/store") {
      if (userInfo.group_id == 1  || userInfo.group_id == 5 || userInfo.group_id == 6 || userInfo.group_id == 10 || userInfo.group_id == 11 || userInfo.group_id == 13 || userInfo.group_id == 14) {
        next()
      } else {
        next("/404")
      }
    } else {
      next()
    }
  } else {
    if (to.path === "/login") {
      next()
    } else {
      next("/login")
    }
  }
})

export default router